import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=d57f0c16&scoped=true&name=TrainingDetail&"
import script from "./TrainingDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TrainingDetail.vue?vue&type=style&index=1&id=d57f0c16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f0c16",
  null
  
)

export default component.exports